import React, {useState } from "react";
import { Link } from "react-router-dom";
import ConfirmModal from "../../../../modals/ConfirmModal";
import { FaRegEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";

const EmployeeList = (props) => {
  const [searchValue, setSearchValue] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [contactId, setContactId] = React.useState(null);
    const [contactType, setContactType] = React.useState(null);
  const handleSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handleDelete = async (id) => {
    try {
        setShowConfirmModal(true);    
        setContactId(id)
        setContactType(props.type)
    } catch (error) {
      console.error('Error delete record:', error);
    }
  };
  const handleEdit = (record) => {
    props.toggleView(props.type, 'form', record);
  }

  const handleAddMore = () => {
      props.toggleView(props.type, 'form')
  }
  const handleCancel = () => {
      setShowConfirmModal(false);
  }
  return (
      <>
        <div className="tab-content">
          <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
              <div className="card">
                  <div className="card-header">
                      <div className="card-title">
                          <div className="row align-items-end">
                              <div className="col">
                                  <h2 className="header-title">
                                      {props.company}
                                  </h2>
                              </div>
                              <div className="col-auto">
                                  <button 
                                      className="btn btn-primary btn-sm" 
                                      onClick={handleAddMore} 
                                  >
                                      Add More
                                  </button >
                              </div>
                          </div>
                      </div>
                  </div>
                <div className="card-header">
                    <div className="row align-items-center">
                      <div className="col">
                          <form>
                          <div className="input-group input-group-flush input-group-merge input-group-reverse">
                              <input
                              className="form-control list-search"
                              type="search"
                              placeholder="Search"
                              value={searchValue}
                              onChange={handleSearchValue}
                              />
                              <span className="input-group-text">
                              <i className="fe fe-search" />
                              </span>
                          </div>
                          </form>
                      </div>
                    </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-sm table-hover table-nowrap card-table">
                      <thead>
                        <tr>
                          <th scope="col">
                            <Link className="list-sort text-body-secondary">Name</Link>
                          </th>
                          <th scope="col">
                            <Link className="list-sort text-body-secondary">Email</Link>
                          </th>                              
                          <th scope="col">
                            <Link className="list-sort text-body-secondary">Phone</Link>
                          </th>
                          <th scope="col">
                            <Link className="list-sort text-body-secondary">Gender</Link>
                          </th>
                          <th scope="col">
                            <Link className="list-sort text-body-secondary">Is Contact Person?</Link>
                          </th> 
                          <th scope="col">
                            <Link className="list-sort text-body-secondary">Action</Link>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="list fs-base">
                      {props.employees.map((row) => (
                          <tr key={row.id}>
                            <td>
                              <Link to="#" onClick={() => handleEdit(row)}> <span className="tables-company text-reset" to="">{row.first_name} {row.last_name}</span></Link>
                            </td>
                            <td>
                                <span className="tables-phone">{row.email}</span>
                            </td>
                            <td>
                                <span className="tables-website">{row.phone}</span>
                            </td>
                            <td>
                                <span className="tables-gender">{row.gender}</span>
                            </td>
                            <td className="text-center">
                            <span className={`tables-is_contact_person badge ${row.is_contact_person ? 'bg-success' : 'bg-danger'}`}>
                              {row.is_contact_person ? 'Yes' : 'No'}
                            </span>
                            </td>
                            <td>
                                <span className="tables-action">
                                  <button className="border border-secondary-subtle rounded text-white bg-primary" onClick={() => handleEdit(row)} >
                                    <FaRegEdit size={18} />
                                  </button > 
                                  {' | '}
                                  <button 
                                      className="border border-secondary-subtle rounded text-white bg-danger" 
                                      onClick={(e) => {
                                          e.preventDefault();
                                          handleDelete(row.id)
                                      }
                                  }><FaTrashAlt size={14} /></button >

                                </span>
                            </td>
                          </tr>
                      ))}
                      </tbody>
                  </table>
                </div>
              </div>
          </div>
        </div>
        { showConfirmModal &&( 
              <ConfirmModal show={showConfirmModal} onCancel={handleCancel} onConfirm={props.onDelete} id={contactId} type={contactType} heading='Delete Contact'
              content='Are you sure you want to delete this contact?'/>
            )
        }
      </>
  )
}

export default EmployeeList; 